export const AwsConfigAuth = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_xqdyN2if5",
    userPoolWebClientId: "3d8fndju02ck04o4kn10bahnf0",
    mandatorySignIn: false,
    cookieStorage: {
      domain: "app-student.nova.dttsynergy.com", //"localhost",
      //domain: "localhost",
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: false,
    },
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
      domain: "synergy.auth.eu-west-1.amazoncognito.com",
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      //redirectSignIn: "http://localhost:3000/",
      redirectSignIn: "https://app-student.nova.dttsynergy.com/", //"http://localhost:3000/", 
      //redirectSignOut: "http://localhost:3000/",
      redirectSignOut: "https://app-student.nova.dttsynergy.com/", //"http://localhost:3000/", 
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
};
